import React from 'react';
import styles from './ArticleAuthor.module.scss';
import { ArticleData } from 'model/Article';
import { NextImage } from '@sitecore-jss/sitecore-jss-nextjs';

type ArticleAuthorProps = {
  author: ArticleData['articleAuthor']['targetItems'][number];
};

const ArticleAuthor: React.FC<ArticleAuthorProps> = ({ author }) => {
  return (
    <div className="d-flex gap-1">
      {author.jobImage?.src && (
        <div className={`position-relative ${styles.authorImageContainer}`}>
          <NextImage
            field={author.jobImage}
            className={styles.authorImage}
            alt={author.jobImage.alt ?? 'Author image'}
            width={40}
            height={48}
          />
        </div>
      )}
      <div className="align-self-center">
        <div className="inline-link inline-link--small">{author.name.value}</div>
        {author.jobTitle?.value && (
          <div className="mt-1 body-small text-grey">{author.jobTitle.value}</div>
        )}
      </div>
    </div>
  );
};

export default ArticleAuthor;
